import React, { useRef, useState } from 'react';
import CusInput from '../../../../components/material-ui/CusInput';
import { API_GROUP } from '../../../../api/user';
import { useDispatch } from 'react-redux';
import { addFSCampaign } from '../../../../store/apps/freeSpinSlice';
import { useAppSelector } from '../../../../store';
import { Stack } from '@mui/material';
import BtnEdit from '../../../../components/bonus/ui/BtnEdit';
import useToast from '../../../../hooks/useToast';

export default function ChangeFsName({ freespinName, campaignId, groupId, setOpenInfo }) {
  const { successToast } = useToast();

  const dispatch = useDispatch();
  const campaignByGroupId = useAppSelector((state) => state.freeSpin.campaignByGroupId);
  const campaigns = campaignByGroupId?.[groupId];
  const currentCompany = campaigns.find((el) => el.campaignId == campaignId);

  const [curFsName, setCurFsName] = useState(freespinName);

  const sendChangeFsName = (value) => {
    const campaignFs = { campaignId: +campaignId, name: curFsName };
    API_GROUP.bonus.freespin.campaign
      .update(campaignFs)
      .then((e) => {
        successToast('Information updated successfully');
        dispatch(addFSCampaign({ groupId, data: { ...currentCompany, name: curFsName } }));
        // setOpenInfo(false);
      })
      .catch(console.error);
  };

  const onChangeFsName = (e) => {
    const value = e.target.value;
    setCurFsName(value);
  };
  return (
    <Stack display={'flex'} gap={1} alignItems={'center'} flexDirection={'row'}>
      <CusInput value={curFsName} onChange={onChangeFsName} />
      <BtnEdit
        variant={2}
        onEditClick={sendChangeFsName}
        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
      />
    </Stack>
  );
}
